export function GenericError({ message }: { message: string }) {
  return (
    <>
      <h2>{message}</h2>
      <div>
        {/* TODO Use locize? */}
        <div>
          <span>Sorry, you had an error!</span>
        </div>
        {/* <br /> */}
        <span>
          If you feel like it you could try refreshing the page and see if the problem goes away.
        </span>
      </div>
    </>
  )
}
